import React, { useEffect, useState } from 'react'

import ViewCollegeDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer'
import CandidatesTable from 'modules/Roles/ViewRole/CandidatesTable'
import CollegesTable from 'modules/Roles/ViewRole/CollegesTable'
import Header from 'modules/Roles/ViewRole/Header'
import { SectionWrapper } from 'modules/Roles/ViewRole/Style/style'
import { useParams } from 'react-router-dom'
import { degreeListConvertion } from 'utils/degreeListConvertion'
import { permittedSubEventCruds } from 'utils/permissionsValidation'

const ViewRole = ({
  getAppliedCollegesList,
  getAppliedCandidateList,
  appliedCandidatesList,
  getInstitutesList,
  institutesList,
  getListOfDegree,
  listOfDegree,
  setInstitutesList,
  singleRoleData,
  closeApplication,
  duplicateRole,
  deleteRole,
  getSingleRoleData,
  getCities,
  listOfCities,
  corporateId,
  createDrive,
  driveList,
  getDriveRoleMetrics,
  driveRoleMetrics,
  getCandidateDetails,
  getPromotion,
  candidateDetails,
  promotionData,
  addRoleToExistingDrive,
  getIndidualDriveData,
  driveData,
  getRolesMetrics,
  driveRolesMetrics,
  requestToChange,
  confirmDrive,
  getRoleAppliedDriveMetrics,
  roleAppliedDriveMetrics,
  jobSharingEmail,
  getDegreesBasedOnRoles,
  getDegreeBasedOnATS,
  roleBasedDegreeList,
  atsBasedDegreeList,
  getRoleViewCard,
  getRoleViewChart,
  getDriveCreatedCandidates,
  getDriveNotCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  DriveNotCreatedCandidates,
  DriveCreatedCandidates,
  DriveCreatedCandidatesPreview,
  permissions,
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  getUserCorpList,
  getRoleDataToExport,
  roleDataToExcel,
  getUniqueStudentInstitutesList,
  getRoleCityData,
  cityRoleData,
  graphList,
  getQuestionaireGraphList,
  recreateCall,
  resumeBulkDownload
}) => {
  let pageLimit = 100
  const [tableType, setTableType] = useState('Colleges')
  const [viewDrawer, setViewDrawer] = useState(false)
  const [createDriveDrawer, setCreateDriveDrawer] = useState(false)
  const [twoDrivesDrawer, setTwoDrivesDrawer] = useState(false)
  const [degreeListData, setDegreeListData] = useState([])
  const [degreeSearch, setDegreeSearch] = useState('')
  const [collegeDataLength, setCollegeDataLength] = useState('')
  const [driveListLoading, setDriveListLoading] = useState(false)
  const [driveModeFilter, setDriveModeFilter] = useState('')
  const [pageNum, setPageNum] = useState(1)
  const [candidateCount, setCandidateCount] = useState(0)
  const [locationLoading, setLocationLoading] = useState(false)
  const [cityData, setCityData] = useState({
    result: [],
    count: 0,
  })

  const [locationSearch, setLocationSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(0)

  const [selectedCity, setSelectedCity] = useState('')
  const [driveName, setDriveName] = useState('')
  const [selectedCityName, setSelectedCityName] = useState('')
  const [hostCollegeId, setHostCollegeId] = useState('')
  const [selectedInstitute, setSelectedInstitute] = useState({})
  const [searchCity, setSearchCity] = useState('')
  const [poolInstituteIds, setPoolInstituteIds] = useState('')
  const [poolInstitutesData, setPoolInstitutesData] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [pageLimitForDrive, setPageLimitForDrive] = useState(10)
  const [previewDrawer, setPreviewDrawer] = useState(false)
  const params = useParams()
  const [createDriveTemplate, setCreateDriveTemplate] = useState(null)
  const [virtualDriveTemplate, setVirtualDriveTemplate] = useState(null)
  const [poolDriveTemplate, setPoolDriveTemplate] = useState(null)
  const [filterDataForReport, setFilterDataForReport] = useState(null)
  const [order, setOrder] = useState(null)
  const [sort, setSort] = useState(null);
  const [selectedStudentId,setSelectedStudentId]= useState([]);
  const [isAllSelected,setIsAllSelected] = useState(false)

  useEffect(() => {
    if (singleRoleData?.length == 0) {
      getSingleRoleData(0,params?.jobId)
    }
  }, [])
  useEffect(() => {
    getRoleViewChart({ roleId: params?.jobId })
    getRoleViewCard({ roleId: params?.jobId })
  }, [])
  

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getListOfDegree({ searchValue: degreeSearch })
    }, 500)

    return () => clearTimeout(getData)
  }, [degreeSearch])

  useEffect(() => {
    const updatedData = degreeListConvertion(listOfDegree)
    setDegreeListData(updatedData)
  }, [listOfDegree])

  useEffect(() => {
    if (selectedCity == '') {
      setSelectedRowKeys([])
    }
  }, [selectedCity])
 
  const loadMoreData = () => {
    let jobId = params.jobId
    let currentPage = currentPage
    getRoleCityData({
      jobId,
      locationSearch,
      setLocationLoading,
      currentPage,
    })
  }
  useEffect(() => {
    const getData = setTimeout(() => {
      loadMoreData()
      setCurrentPage(0)
    }, 500)
    return () => clearTimeout(getData)
  }, [locationSearch])

  useEffect(() => {
    if (cityRoleData?.result?.length > 0) {
      setCurrentPage(currentPage + 1)
      setCityData({
        count: cityRoleData?.count,
        result: [...(cityData?.result || []), ...(cityRoleData?.result || [])],
      })
    } else {
      setCurrentPage(0)
      setCityData({
        count: 0,
        result: [],
      })
    }
  }, [cityRoleData])

  useEffect(() => {
    getQuestionaireGraphList({ roleId: params?.jobId, type: 'OVERVIEW' })
  }, [])

  return (
    <>
      <SectionWrapper column>
        <Header
          order={order}
          sort={sort}
          filterDataForReport={filterDataForReport}
          candidateCount={candidateCount}
          roleDataToExcel={roleDataToExcel}
          getRoleDataToExport={getRoleDataToExport}
          tableType={tableType}
          setTableType={setTableType}
          setViewDrawer={setViewDrawer}
          createDriveDrawer={createDriveDrawer}
          setCreaterDriveDrawer={setCreateDriveDrawer}
          setTwoDriveDrawer={setTwoDrivesDrawer}
          twoDrivesDrawer={twoDrivesDrawer}
          singleRoleData={singleRoleData}
          closeApplication={closeApplication}
          duplicateRole={duplicateRole}
          deleteRole={deleteRole}
          getCities={getCities}
          listOfCities={listOfCities}
          degreeListData={degreeListData}
          degreeSearch={degreeSearch}
          setDegreeSearch={setDegreeSearch}
          getAppliedCollegesList={getAppliedCollegesList}
          getAppliedCandidateList={getAppliedCandidateList}
          corporateId={corporateId}
          createDrive={createDrive}
          collegeDataLength={collegeDataLength}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
          selectedCityName={selectedCityName}
          setSelectedCityName={setSelectedCityName}
          hostCollegeId={hostCollegeId}
          setHostCollegeId={setHostCollegeId}
          selectedInstitute={selectedInstitute}
          setSelectedInstitute={setSelectedInstitute}
          searchCity={searchCity}
          jobId={params.jobId}
          setSearchCity={setSearchCity}
          poolInstituteIds={poolInstituteIds}
          setPoolInstituteIds={setPoolInstituteIds}
          poolInstitutesData={poolInstitutesData}
          setPoolInstitutesData={setPoolInstitutesData}
          driveList={driveList}
          driveListLoading={driveListLoading}
          driveModeFilter={driveModeFilter}
          setDriveModeFilter={setDriveModeFilter}
          pageLimit={pageLimit}
          setPageNum={setPageNum}
          getDriveRoleMetrics={getDriveRoleMetrics}
          driveRoleMetrics={driveRoleMetrics}
          requestToChange={requestToChange}
          confirmDrive={confirmDrive}
          getRoleAppliedDriveMetrics={getRoleAppliedDriveMetrics}
          roleAppliedDriveMetrics={roleAppliedDriveMetrics}
          previewDrawer={previewDrawer}
          setPreviewDrawer={setPreviewDrawer}
          setPageLimitForDrive={setPageLimitForDrive}
          jobSharingEmail={jobSharingEmail}
          getDegreesBasedOnRoles={getDegreesBasedOnRoles}
          getDegreeBasedOnATS={getDegreeBasedOnATS}
          roleBasedDegreeList={roleBasedDegreeList}
          atsBasedDegreeList={atsBasedDegreeList}
          getDriveCreatedCandidates={getDriveCreatedCandidates}
          getDriveNotCreatedCandidates={getDriveNotCreatedCandidates}
          getDriveCreatedCandidatesPreview={getDriveCreatedCandidatesPreview}
          DriveNotCreatedCandidates={DriveNotCreatedCandidates}
          DriveCreatedCandidates={DriveCreatedCandidates}
          DriveCreatedCandidatesPreview={DriveCreatedCandidatesPreview}
          createDriveTemplate={createDriveTemplate}
          sendNotificationBulkEmail={sendNotificationBulkEmail}
          getUserCorpList={getUserCorpList}
          virtualDriveTemplate={virtualDriveTemplate}
          setCandidatesCount={setCandidateCount}
          poolDriveTemplate={poolDriveTemplate}
          draftData={singleRoleData}
          graphList={graphList}
          setDriveName={setDriveName}
          driveName={driveName}
          recreateCall={recreateCall}
        />

        {tableType == 'Colleges' ? (
          <CollegesTable
            draftData={singleRoleData}
            loadMore={loadMoreData}
            setLocationSearch={setLocationSearch}
            locationSearch={locationSearch}
            cityData={cityRoleData}
            setCityData={setCityData}
            locationLoading={locationLoading}
            setLocationLoading={setLocationLoading}
            jobId={params.jobId}
            cityRoleData={cityRoleData}
            getRoleCityData={getRoleCityData}
            getAppliedCollegesList={getAppliedCollegesList}
            setCollegeDataLength={setCollegeDataLength}
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            selectedCityName={selectedCityName}
            setSelectedCityName={setSelectedCityName}
            hostCollegeId={hostCollegeId}
            setHostCollegeId={setHostCollegeId}
            selectedInstitute={selectedInstitute}
            setSelectedInstitute={setSelectedInstitute}
            searchCity={searchCity}
            setSearchCity={setSearchCity}
            poolInstituteIds={poolInstituteIds}
            setPoolInstituteIds={setPoolInstituteIds}
            poolInstitutesData={poolInstitutesData}
            setPoolInstitutesData={setPoolInstitutesData}
            selectedRowkeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            degreeListData={degreeListData}
            degreeSearch={degreeSearch}
            setDegreeSearch={setDegreeSearch}
            singleRoleData={singleRoleData}
            getIndidualDriveData={getIndidualDriveData}
            driveData={driveData}
            getRolesMetrics={getRolesMetrics}
            driveRolesMetrics={driveRolesMetrics}
            getAppliedCandidateList={getAppliedCandidateList}
            addRoleToExistingDrive={addRoleToExistingDrive}
            createDriveDrawer={createDriveDrawer}
            previewDrawer={previewDrawer}
            getDegreesBasedOnRoles={getDegreesBasedOnRoles}
            roleBasedDegreeList={roleBasedDegreeList}
            setCandidatesCount={setCandidateCount}
          />
        ) : (
          <CandidatesTable
            draftData={singleRoleData}
            getPromotion={getPromotion}
            setFilterDataForExport={setFilterDataForReport}
            setOrder={setOrder}
            setSort={setSort}
            setViewDrawer={setViewDrawer}
            driveData={driveData}
            getAppliedCandidateList={getAppliedCandidateList}
            appliedCandidatesList={appliedCandidatesList}
            getInstitutesList={getInstitutesList}
            institutesList={institutesList}
            setInstitutesList={setInstitutesList}
            degreeListData={degreeListData}
            getCandidateDetails={getCandidateDetails}
            getDegreesBasedOnRoles={getDegreesBasedOnRoles}
            roleBasedDegreeList={roleBasedDegreeList}
            setCandidatesCount={setCandidateCount}
            getUniqueStudentInstitutesList={getUniqueStudentInstitutesList}
            selectedStudentId={selectedStudentId}
            setSelectedStudentId={setSelectedStudentId}
            isAllSelected={isAllSelected}
            setIsAllSelected={setIsAllSelected}
            resumeBulkDownload={resumeBulkDownload}
          />
        )}
      </SectionWrapper>

      <ViewCollegeDetails
        viewDrawer={viewDrawer}
        setViewDrawer={setViewDrawer}
        singleStudentData={candidateDetails}
        promotionData={promotionData}
        getUserCorpList={getUserCorpList}
        setCandidatesCount={setCandidateCount}
        roleId={params?.jobId}
      />
    </>
  )
}

export default ViewRole
